import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import PreviousSubmitBtn from '../../../components/Button/PreviousSubmitBtn';
import {
  CustomRadio,
  CustomRadioGroup,
} from '../../../components/FormCom/CustomRadioField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import OptionalFormField from '../../../components/FormCom/OptionalFormField';
import { TranslatingContainerContext } from '../../../components/TranslatingContainer/TranslatingContainerProvider';
import {
  SignUpOptionsDataType,
  signUpOptionsInitialValues,
  SignUpOptionsSchema,
} from '../../../models/auth/signUp/signUpOptions.model';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { useAppDisPatch } from '../../../redux/store';

const SignUpOptionsForm = () => {
  const dispatch = useAppDisPatch();
  const { sliderIndex, setSliderIndexPos } = React.useContext(
    TranslatingContainerContext,
  )!;

  const onSubmit = (value: SignUpOptionsDataType) => {
    dispatch(signUpActions.setOptionsSlider(value));
    setSliderIndexPos(1);
  };

  return (
    <Container sliderIndex={sliderIndex}>
      <FormComponent
        initialValues={signUpOptionsInitialValues}
        schema={SignUpOptionsSchema}
        onSubmit={onSubmit}
      >
        <CustomRadioGroup name='accountCreatorRole' className='slim-error'>
          <CustomRadio name='accountCreatorRole' value='Founder/C-Level'>
            Founder/C-Level
          </CustomRadio>
          <CustomRadio name='accountCreatorRole' value='OperationsManager'>
            Operations Manager
          </CustomRadio>
          <CustomRadio name='accountCreatorRole' value='OperationsDirector'>
            Operations Director
          </CustomRadio>
          <CustomRadio name='accountCreatorRole' value='LogisticsManager'>
            Logistics Manager
          </CustomRadio>
          <CustomRadio name='accountCreatorRole' value='Distribution Manager'>
            Distribution Manager
          </CustomRadio>
          <CustomRadio name='accountCreatorRole' value='FleetOwner'>
            Fleet Owner
          </CustomRadio>
          <CustomRadio name='accountCreatorRole' value='RoleNotListed'>
            Role not listed
          </CustomRadio>
        </CustomRadioGroup>

        <OptionalFormField
          conditionKey='accountCreatorRole'
          conditionValue={'RoleNotListed'}
          resetField='customRole'
        >
          <HorizontalLine />
        </OptionalFormField>

        <OptionalFormField
          conditionKey='accountCreatorRole'
          conditionValue={'RoleNotListed'}
          resetField='customRole'
        >
          <TextInputField
            label='Enter your Role'
            name='customRole'
            id='customRole'
            type='text'
            placeholder='Input your preferred role'
          />
        </OptionalFormField>

        <FormButtonArea>
          <PreviousSubmitBtn>Go Back</PreviousSubmitBtn>
          <FormSubmitButton className='large'>Next</FormSubmitButton>
        </FormButtonArea>
      </FormComponent>
    </Container>
  );
};

export default SignUpOptionsForm;

interface ContainerProp {
  sliderIndex: number;
}

const Container = styled.div<ContainerProp>`
  flex-direction: column;
  gap: 8px;
  display: ${({ sliderIndex }) => (sliderIndex >= 1 ? 'flex' : 'none')};
`;

const FormButtonArea = styled.div`
  display: grid;
  grid-template-columns: 120px auto;
  gap: 24px;
  margin-top: 12px;
`;

const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
`;
